import ProgressBar from '../ProgressBar/ProgressBar';

// Styles
import * as S from './ExtrenalRatingBreakup.styles';

import {getRatingsColor} from '@stencil/hotels-utils/src/get-ratings-colors';

const RatingsBreakup = ({subRating}) => {
  const getBarWidth = rating => {
    let barWidth = (rating * 270) / 50;
    return barWidth;
  };

  if (!subRating) return null;

  return (
    <S.WrapperDiv>
      {subRating?.map(item => {
        const rating = item.value / 20;
        return (
          <S.RatingRow key={item.concept}>
            <S.ReviewHeaderWrapper>
              <S.ReviewTypeTextWrapper>{item.displayText}</S.ReviewTypeTextWrapper>
              <span>{rating.toFixed(1)}</span>
            </S.ReviewHeaderWrapper>
            <S.ProgressBarWrapperDiv>
              <ProgressBar width={getBarWidth(rating)} bgColor={getRatingsColor(rating)} />
            </S.ProgressBarWrapperDiv>
          </S.RatingRow>
        );
      })}
    </S.WrapperDiv>
  );
};

const ExternalRatingsBreakup = ({hotelRating, ratingCount, extRating}) => {
  return (
    <S.ExternalGuestReviewWrapper>
      <S.EGRInnerWrapper>
        <S.FlexContainerWrap>
          <S.GoRatingBlock hotelRating={hotelRating}>
            <S.AvgReviewTextWrapperDiv>
              <S.AvgReviewTextWrapper>{hotelRating}</S.AvgReviewTextWrapper>
              <S.TotalReviewTextWrapper>/5</S.TotalReviewTextWrapper>
            </S.AvgReviewTextWrapperDiv>
            <S.RatingsCountTextWrapper>{ratingCount} Ratings</S.RatingsCountTextWrapper>
          </S.GoRatingBlock>
          <RatingsBreakup subRating={extRating} />
        </S.FlexContainerWrap>
      </S.EGRInnerWrapper>
    </S.ExternalGuestReviewWrapper>
  );
};

export default ExternalRatingsBreakup;
